export { default } from "./CuratedFormativeOption";
